export function Void(): void {}
